import React, { useState } from 'react'
import './Reviewbutton.css'
import ReviewForm from './ReviewForm.js'
import { useLocation } from 'react-router-dom'

const Reviewbutton = () => {
    const [isFormOpen, setIsFormOpen] = useState(false);
    const location = useLocation();
    
    // Get facilities from the current page data
    // This will be passed from Homepage component
    const [facilities, setFacilities] = useState([]);

    // Load facilities when component mounts
    React.useEffect(() => {
        const loadFacilities = async () => {
            try {
                const [mriRes, ctRes] = await Promise.all([
                    fetch('/mri_wait_times.json'),
                    fetch('/ct_wait_times.json')
                ]);
                const [mriData, ctData] = await Promise.all([
                    mriRes.json(),
                    ctRes.json()
                ]);
                // Combine and deduplicate facilities
                const allFacilities = [...mriData, ...ctData];
                const uniqueFacilities = Array.from(
                    new Map(allFacilities.map(f => [f.hospital, f])).values()
                );
                setFacilities(uniqueFacilities);
            } catch (error) {
                console.error('Error loading facilities:', error);
            }
        };
        loadFacilities();
    }, []);

    return (
        <>
            <div>
                <button 
                    type='button' 
                    className='reviewbutton'
                    onClick={() => setIsFormOpen(true)}
                >
                    <span className='review-icon'>+</span> Add review
                </button>
            </div>
            <ReviewForm 
                isOpen={isFormOpen} 
                onClose={() => setIsFormOpen(false)}
                facilities={facilities}
            />
        </>
    )
  }
  
  export default Reviewbutton;
